<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Fees Payment Receipt",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      current_data: moment(new Date()).format("DD-MM-YYYY"),
      id: atob(this.$route.params.id),
    };
  },
  computed: {
    ...mapGetters("fees", ["FeesReceipt"]),
  },
  watch: {
    //   FeesReceipt(newValue) {
    //       if(newValue){
    //           this.calcTot();
    //       }
    //   }
  },
  methods: {
    ...mapActions({
      FetchReceipt: "fees/fetchReceipt",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
  },
  updated() {
    // setTimeout(() => {
    //   window.print();
    // }, 1000);
  },
  created() {
    this.FetchReceipt(this.id);
  },
};
</script>

<style scoped>
.print-font {
  font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter,
    monospace;
}
</style>

<template>
  <Layout>
    <div class="row d-flex">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print Receipt</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>

        <div class="bg-white col-md-6 mx-auto">
          <div class="print-font p-3">
            <b-spinner
              v-if="!FeesReceipt"
              class="m-0"
              variant="primary"
              role="status"
            ></b-spinner>
            <div class="mt-3" v-else>
              <center>
                <!-- <br /> -->
                <img
                    :src="FeesReceipt.school.badge"
                    alt="school logo"
                    height="50"
                    width="50"><br>
                <strong style="font-size: 21px">
                  {{ FeesReceipt ? FeesReceipt.school.name : "---" }}</strong
                >
                <div class="row">
                  <div class="col-md-12">
                    <p style="font-size: 20px">
                  <span>
                    {{
                      FeesReceipt ? FeesReceipt.school.location : "---"
                    }}</span
                  >
                  <br />
                  {{ FeesReceipt ? FeesReceipt.school.contacts : "---" }}
                  <br />
                  <!-- {{ FeesReceipt ? FeesReceipt.school.email : "---" }}
                  <br /> -->
                  Receipt No: #{{
                    FeesReceipt ? FeesReceipt.receipt.receipt : ""
                  }}
                </p>
                  </div>
                </div>
              </center>

              <!-- <hr style="border-style: dashed; width: 100%" /> -->
              <h5
                style="
                  text-align: center;
                  font-weight: bold;
                  font-family: Courier New, Courier, Lucida Sans Typewriter,
                    Lucida Typewriter, monospace;
                "
              >
              </h5>
              <table width="100%" class="mTable" style="font-size: 20px">
                  <tr width="100%">
                    <td width="20%">Name:</td>
                    <td width="30%">
                      <strong>{{ FeesReceipt ? FeesReceipt.name : "" }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td width="20%">Class:</td>
                    <td width="30%">
                      <strong>{{
                        FeesReceipt ? FeesReceipt.class : ""
                      }} Term {{FeesReceipt ? FeesReceipt.receipt.term : ""}}</strong>
                    </td>
                  </tr>
              </table>
              <br />
              <!-- <h4>Payment Details</h4> -->
              <!-- <hr style="border-style: dashed; width: 100%" /> -->
              <table width="100%" class="mTable" style="font-size: 20px">
                <td width="100%">
                  <tr width="100%">
                    <td width="20%">Amount Paid:</td>
                    <td width="30%">
                      <strong
                        >{{ FeesReceipt ? FeesReceipt.amount : "" }}/=</strong
                      >
                    </td>
                  </tr>
                  <tr width="100%">
                    <td width="20%">Amount in Words:</td>
                    <td width="30%">
                      <strong>{{
                        FeesReceipt ? FeesReceipt.words : ""
                      }}</strong>
                    </td>
                  </tr>
                  <tr width="100%">
                    <td width="20%">Balance:</td>
                    <td width="30%">
                      <strong
                        >{{ FeesReceipt ? FeesReceipt.bal : "" }}/=</strong
                      >
                    </td>
                  </tr>
                  <!-- <tr width="100%">
                    <td width="20%">Recorded By:</td>
                    <td width="30%">
                      <strong>{{ FeesReceipt ? FeesReceipt.user : "" }}</strong>
                    </td>
                  </tr> -->
                  <tr>
                    <td width="20%">Payment Date:</td>
                    <td width="30%">
                      <strong>{{
                        FeesReceipt ? FeesReceipt.receipt.date : ""
                      }}</strong>
                    </td>
                  </tr>
                  <tr width="100%">
                    <td width="20%">Payment Mode:</td>
                    <td width="30%">
                      <strong>{{ FeesReceipt ? FeesReceipt.mode : "" }}</strong>
                    </td>
                  </tr>

                  <tr width="100%">
                    <td width="20%">Slip/Ref:</td>
                    <td width="30%">
                      <strong>{{
                        FeesReceipt ? FeesReceipt.receipt.slip : ""
                      }}</strong>
                    </td>
                  </tr>

                </td>
              </table>
              <hr style="border-style: dashed; width: 100%" />
              <table width="100%" class="mTable" style="font-size: 20px">
                <td width="50%">
                  <tr width="100%">
                    <td width="20%">Printed By:</td>
                    <td width="30%">
                      <strong>{{
                        FeesReceipt ? FeesReceipt.print : ""
                      }}</strong>
                    </td>
                  </tr>
                  <br />
                  <tr width="100%">
                    <td width="20%">Signature:</td>
                    <td width="30%" class="dot"></td>
                  </tr>
                </td>
                <td width="50%">
                  <tr>
                    <td width="20%">Date:</td>
                    <td width="30%">
                      <strong>{{ current_data }}</strong>
                    </td>
                  </tr>
                  <br />
                  <tr width="100%">
                    <td width="20%">School Stamp:</td>
                    <td width="30%" class="dot"></td>
                  </tr>
                </td>
              </table>
              <center>
                <br />
                <!-- <p style="font-size: 15px">
                  Printed from Academic Master. For inquiries call
                  <strong>
                    {{
                      FeesReceipt ? FeesReceipt.school.contacts : "---"
                    }}</strong
                  >
                </p>
                <br /> -->
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.dot {
  border-bottom: 1px dotted black;
}
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>